export const CONTENT_ITEM = 'contentItem';
export const TERM = 'term';
export const AUTHOR = 'author';
